// extracted by mini-css-extract-plugin
module.exports = {"title":"TextTitle_title__SWt1V"};